import NotificationWithoutRedirection from "@features/notifications/NotificationToasts/components/NotificationWithoutRedirection";
import NotificationWithRedirection from "@features/notifications/NotificationToasts/components/NotificationWtihRedirection";

import { NotificationTypeEnum } from "./types";

export const NotificationComponentFactory = ({
  notificationType = NotificationTypeEnum.default,
}) => {
  switch (notificationType) {
    case NotificationTypeEnum.notificationWithLink:
      return NotificationWithRedirection;

    case NotificationTypeEnum.notificationWithoutLink:
    case NotificationTypeEnum.default:
    default:
      return NotificationWithoutRedirection;
  }
};
